import SvgIcon from './SvgIcon.vue'

export default SvgIcon
